export default __webpack_public_path__ + "static/media/labeledtext_element.59b94b57.svg";